import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { AppService, I18nService, LgType, SetColorsService } from 'core'

@Component({
  selector: 'bmprod-header',
  templateUrl: './bmprod-header.component.html',
  styleUrls: ['./bmprod-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodHeaderComponent implements OnInit {
  @Input() currentRoute: string

  lg: LgType
  colorSettingsMode = false

  logoUrl = ''
  beatmakerName = ''

  constructor(
    private i18nService: I18nService,
    private setColorsService: SetColorsService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.getColorSettingsMode()
    this.getBeatmakerData()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.logoUrl = res.logoUrl
        this.beatmakerName = res.beatmakerName
      }
    })
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }

  checkIsLinkActive(route: string) {
    if (route === 'home') {
      return this.currentRoute === '/' || this.currentRoute === '/?devBeatmakerId=4'
    } else {
      return this.currentRoute.includes(route)
    }
  }
}
